module.exports = __webpack_public_path__ + "img/trainingPlan.9feabb36.png";